import React, { useState } from 'react';
import { signUp } from '@aws-amplify/auth';
import { useNavigate } from "react-router-dom";
import {Amplify} from 'aws-amplify';
import awsconfig from '../aws-exports';

Amplify.configure(awsconfig);

function CreateUser({ onUserCreated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if (isCreating) return;

    if (!username || !password || !email) {
      alert('All fields are required');
      return;
    }

    setIsCreating(true);

    try {
      const { user } = await signUp({
        username,
        password,
        attributes: {
            email
        }
      });
      console.log('User created: ', user);
      onUserCreated();
      navigate('/app'); // Navigate to a success page or dashboard
    } catch (error) {
      console.error('Error creating user:', error);
      alert('Error creating user: ' + error.message);
    } finally {
      setIsCreating(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f2f2f2',
        userSelect: 'none'
      }}>
      <form onSubmit={handleCreateUser} style={{
          width: '300px',
          padding: '40px',
          backgroundColor: '#ffffff',
          borderRadius: '5px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: '24px',
          marginBottom: '20px'
        }}>Create Account</h2>
        <div style={{ marginBottom: '20px' }}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #cccccc',
              borderRadius: '5px'
            }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #cccccc',
              borderRadius: '5px'
            }}
          />
          <button onClick={togglePasswordVisibility} style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer'
          }}>
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #cccccc',
              borderRadius: '5px'
            }}
          />
        </div>
        <button
          type="submit"
          disabled={isCreating}
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            backgroundColor: '#4681E1',
            color: '#ffffff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Create Account
        </button>
      </form>
    </div>
  );
}

export default CreateUser;